import React from 'react';
import AtlaskitIcon from '@atlaskit/icon';

const IconSvg = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
    >
        <path
            d='M9.09201 2C10.409 2 11.445 3.111 11.336 4.408L11.1 7.227C11.0509 7.7725 10.7988 8.27969 10.3936 8.6482C9.98846 9.01672 9.4597 9.21971 8.91201 9.217H8.88601C8.77201 10.079 8.71501 10.947 8.71501 11.807V11.979C8.71501 12.9 8.78101 13.84 8.91201 14.784C10.054 14.784 11.005 15.65 11.1 16.774L11.337 19.592C11.446 20.89 10.41 22 9.09201 22H7.46201C6.08701 22 4.83801 21.092 4.35301 19.741C3.4553 17.2521 2.99747 14.6259 3.00001 11.98V11.809C3.00001 9.199 3.45301 6.648 4.34901 4.228C4.84901 2.874 6.06401 2 7.44601 2H9.09201ZM9.09301 4.222H7.44601C7.02101 4.222 6.63501 4.523 6.46301 4.989C5.65643 7.17179 5.24567 9.48096 5.25001 11.808V11.978C5.25001 14.376 5.65501 16.722 6.45601 18.951C6.64401 19.472 7.03201 19.778 7.46301 19.778H9.09301L8.86001 17.007H7.00701L6.84201 16.092C6.59335 14.7351 6.46685 13.3585 6.46401 11.979V11.808C6.46401 10.511 6.58101 9.2 6.81401 7.911L6.97801 6.994H8.86001L9.09301 4.222ZM18.546 10.333C19.477 10.333 20.233 11.08 20.233 12C20.233 12.921 19.477 13.667 18.546 13.667C18.3257 13.6684 18.1073 13.6265 17.9032 13.5435C17.6991 13.4605 17.5134 13.3381 17.3566 13.1833C17.1998 13.0284 17.0751 12.8443 16.9896 12.6412C16.904 12.4382 16.8593 12.2203 16.858 12C16.858 11.08 17.614 10.333 18.546 10.333ZM14.046 10.333C14.977 10.333 15.733 11.08 15.733 12C15.733 12.921 14.977 13.667 14.046 13.667C13.8257 13.6684 13.6073 13.6265 13.4032 13.5435C13.1991 13.4605 13.0134 13.3381 12.8566 13.1833C12.6998 13.0284 12.5751 12.8443 12.4896 12.6412C12.404 12.4382 12.3593 12.2203 12.358 12C12.358 11.08 13.114 10.333 14.046 10.333Z'
            fill='#44546F'
        />
    </svg>
);

const UsPhoneNumberIcon = ({ label = '' }) => (
    <AtlaskitIcon
        glyph={IconSvg}
        label={label}
    />
);

export default UsPhoneNumberIcon;
